export const config = {
  base_url: process.env.REACT_APP_BASE_URL,
  public_url: process.env.REACT_APP_PUBLIC_URL,
  // api
  api: {
    isExpired: 401,
    url: process.env.REACT_APP_API_URL,
    socket_url: process.env.REACT_APP_SOCKET_URL,
    cloudImgPath: process.env.REACT_APP_S3_URL,
  },
  mapApiKey: "AIzaSyBInycaDtYijb7243kjYQzthdIxD3ZCXUg",
  // others
  tenantId: 33,
  userId: 5514, // 6325
  cryptKey: "#cErLyPpKt#",
  // elements
  elements: {
    dp: {
      A: "MMMM DD, YYYY",
      B: "MMM DD, YYYY",
      C: "MMM DD, YYYY hh:mm A",
    },
    singleDp: {
      singleDatePicker: true,
      showDropdowns: true,
      locale: {
        format: "MMMM DD, YYYY",
      },
      autoApply: true,
      autoUpdateInput: false,
      isClearable: true,
    },
    toast: {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    },
  },
  subject: {
    name_min: 3,
    name_max: 30,
  },
  statusCategory: [
    { label: "Application Review", value: "review", disabled: true },
    {
      label: "Submitted To University",
      value: "submitted_to_university",
      disabled: true,
    },
    { label: "Course Suggestion", value: "course_suggestion", disabled: false },
    {
      label: "Missing Information",
      value: "missing_information",
      disabled: false,
    },
    { label: "Interview", value: "interview", disabled: false },
    { label: "Document Upload", value: "document_upload", disabled: false },
    { label: "Document Request", value: "document_request", disabled: false },
    { label: "Intake Differ", value: "intake_differ", disabled: false },
    { label: "Course Fee", value: "course_payment", disabled: false },
    { label: "Enrolled", value: "enrolled", disabled: false },
    { label: "Application Withdrawn", value: "cancelled", disabled: false },
    { label: "Application Rejected", value: "rejected", disabled: false },
    { label: "Message", value: "update", disabled: false },
  ],
  missingFields: [
    { label: "Personal - FirstName", value: "personal_firstName" },
    { label: "Personal - LastName", value: "personal_lastName" },
    { label: "Personal - Dob", value: "personal_dob" },
    { label: "Personal - Gender", value: "personal_gender" },
    { label: "Personal - Nationality", value: "personal_nationality" },
    { label: "Personal - FirstLanguage", value: "personal_firstLanguage" },
    { label: "Personal - MaritalStatus", value: "personal_maritalStatus" },
    {
      label: "Address - AddressWithRegion",
      value: "address_addressWithRegion",
    },
    { label: "Address - City", value: "address_city" },
    { label: "Address - Country", value: "address_country" },
    { label: "Address - Province", value: "address_province" },
    { label: "Address - PostalCode", value: "address_postalCode" },
    { label: "Address - Email", value: "address_email" },
    { label: "Address - Mobile", value: "address_mobile" },
    {
      label: "Education - CountryOfEducation",
      value: "education_countryOfEducation",
    },
    {
      label: "Education - HighLevelOfEducation",
      value: "education_highLevelOfEducation",
    },
    { label: "Education - Grade", value: "education_grade" },
    {
      label: "College - InstitutionCountry",
      value: "college_institutionCountry",
    },
    { label: "College - InstitutionName", value: "college_institutionName" },
    { label: "College - Qualification", value: "college_qualification" },
    { label: "College - Degree", value: "college_degree" },
    { label: "College - StartDate", value: "college_startDate" },
    { label: "College - EndDate", value: "college_endDate" },
    { label: "College - GraduationDate", value: "college_graduationDate" },
    { label: "College - GradingSystem", value: "college_gradingSystem" },
    { label: "College - College score", value: "college_score" },
    { label: "College - College Documents", value: "college_docs" },
    {
      label: "Background - PassportNumber",
      value: "background_passportNumber",
    },
    {
      label: "Background - Have You Applied for SFE before?",
      value: "background_isFinanceTakenBefore",
    },
    {
      label: "Background - CRN",
      value: "background_crn",
    },
    {
      label: "Background - SRN",
      value: "background_srn",
    },
    {
      label: "Background - Funding Type",
      value: "background_fundingType",
    },
    {
      label: "Background - Funding Taken",
      value: "background_fundingTaken",
    },
    {
      label: "Background - Are you a Refugee/ Asylum Seeker?",
      value: "background_refugee",
    },
    {
      label:
        "Background - Have you spent any time in public care up to the age of 18?",
      value: "background_publicCare",
    },
    {
      label: "Background - Disability/special needs?",
      value: "background_disability",
    },
    {
      label: "Background - How many years of funding have you taken before?",
      value: "background_financeYearTakenBefore",
    },
    {
      label: "Background - What is your Visa Status?",
      value: "background_visaStatus",
    },
    {
      label: "Background - How long have you been living in UK?",
      value: "background_livingPeriod",
    },
    { label: "Work Experience - Company Name", value: "workExp_companyName" },
    { label: "Work Experience - Designation", value: "workExp_designation" },
    { label: "Work Experience - JoinDate", value: "workExp_joinDate" },
    { label: "Work Experience - EndDate", value: "workExp_endDate" },
    {
      label: "Work Experience - Line Manager Name",
      value: "workExp_lineManagerName",
    },
    {
      label: "Work Experience - Line Manager Work Email",
      value: "workExp_lineManagerEmail",
    },
    {
      label: "Work Experience - Line Manager Designation",
      value: "workExp_lineManagerDesignation",
    },
    { label: "Work Experience - Company Email", value: "workExp_companyEmail" },
    {
      label: "Work Experience - Company Address",
      value: "workExp_companyAddress",
    },
    { label: "Work Experience - Documents", value: "workExp_docs" },
    {
      label: "Other - Documents",
      value: "modal_otherActivity",
    },
    {
      label: "Extra - Curricular Documents",
      value: "modal_extraCurricular",
    },
    {
      label: "Passport Document",
      value: "modal_passportDocs",
    },
  ],
  missingStatus: [
    { value: "missing", label: "Missing" },
    { value: "under_review", label: "Under Review" },
    { value: "reviewed", label: "Reviewed" },
  ],
  interviewStatus: [
    { value: "Scheduled", label: "Scheduled", disabled: true },
    { value: "Attended", label: "Attended", disabled: false },
    { value: "Not Attended", label: "Not Attended", disabled: false },
    { value: "Cancelled", label: "Cancelled", disabled: true },
    { value: "Rescheduled", label: "Rescheduled", disabled: true },
    { value: "Confirmed", label: "Confirmed", disabled: true },
  ],
};
